export const CHART_TYPE = {
  ChartBar: 'CHART_BAR',
  ChartColumn: 'CHART_COLUMN',
  ChartLine: 'CHART_LINE',
  ChartPie: 'CHART_PIE',
  Table: 'TABLE',
  ChartColumnLine: 'CHART_COLUMN_LINE',
  TableInjuryFreeDays: 'TABLE_INJURY_FREE_DAYS',
  ChartKpi: 'CHART_KPI',
  ChartColumnRate: 'CHART_COLUMN_RATE',
  ChartColumnBasic: 'CHART_COLUMN_BASIC',
  MapWidget: 'MAP',
  ManagementTable: 'MANAGEMENT_TABLE',
  ChartDifference: 'CHART_DIFFERENCE',
  ChartRollingFR: 'CHART_ROLLINGFR',
  ComparedFrLine: 'COMPARED_FR_LINE',
  CrossTabReport: 'CROSS_TAB_REPORT',
  TableRollingTRIFR: 'TABLE_ROLLING_TRIFR',
  TableRate: 'TABLE_RATE',
  ColumnKpiPercentage: 'CHART_COLUMN_KPI_PERCENTAGE',
  TableInjurySite: 'INJURY_NUMBER_BY_SITE_TABLE',
  NCRAgingLineChart: 'CHART_NCR_AGING',
} as const;
export type CHART_TYPE = (typeof CHART_TYPE)[keyof typeof CHART_TYPE];

export const TIME_SORT = {
  MONTHLY: 'MONTHLY',
} as const;
export type TIME_SORT = (typeof TIME_SORT)[keyof typeof TIME_SORT];

export const SelectionSearchTypeProps = {
  COMBOBOX: 'MultiSelect',
  RISKRATING: 'TextSearch',
  MULTISELECTCOMBOBOX: 'MultiSelect',
  DATETIME: 'DateRange',
  NUMBER: 'Integer',
  TEXT: 'TextSearch',
} as const;
export type SelectionSearchTypeProps = (typeof SelectionSearchTypeProps)[keyof typeof SelectionSearchTypeProps];
